module.exports = __webpack_public_path__ + "static/media/allBottomImg.e0f8d72c.jpg";